<template>

	<div class="select-exchanges" title="Select your exchanges.">
		<b-button :variant="getButtonVariant()" :size="size" ref="exchangesButton" @click="showExchangeItems()"><span v-html="displayExchangeSelectedHtml()"></span></b-button>
		<form-filterlist header="Select Your Exchanges" v-bind:item-factory="getExchangeItems" v-bind:item-display="displayExchangeItem" v-bind:item-style="getItemClass" v-bind:item-html="getItemHtml" v-bind:item-selected="toggleExchange" v-bind:refresh-items="true" v-bind:hide-on-select="false" ref="exchangeItems"></form-filterlist>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

.selectedExchange {
	background-color: #a1ff8e;
}

.cursor-pointer {cursor: pointer}

<script>
import FormFilterlist from '@/components/FormFilterlist';

var Cookies = require('browser-cookies');

export default {
  name: '',
  components: {'form-filterlist': FormFilterlist},
  props: {
	  'size': {type: String,  default: function() { return "sm" }},
  },
  data () {
    return {
      loadingSpinner: true,
      msg: '',
      exchangeList: [],
      exchanges: {},
      primaryExchange: null,
//      myExchanges: {},
      loadingExchanges: true,
      savedExchanges: null,

    }
  },

  computed: {

	  myExchanges: function() {
		// load selected exchange list
		return this.$root.$store.getters['CCStore/myExchanges'];
	  }
  },

  mounted: function () {

//	    if (this.currencyList) {
//	    	this.currencyItems = Object.keys(this.currencyList).sort();
//	    }

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

//			// restore last profit/loss settings
//			var profitAmount = this.rememberData('profitAmount') || 0;
//			this.$set(this.profitLoss, 'profitAmount', profitAmount);


			this.initializeData();


		});
	},

  methods: {

	  showExchangeItems() {

		  if (this.$refs.exchangeItems) {
			  this.$refs.exchangeItems.showItems();
		  }

	  },

	  hasSavedExchanges() {

		   if ((this.myExchanges) && (typeof this.myExchanges == 'object') && (Object.keys(this.myExchanges).length)) {
			   return true;
		   }

		   return false;
	  },

	  displayExchangeSelectedHtml() {

		var selectCount = Object.keys(this.myExchanges).length;

		// If user has selected a currency, it will be stored in a cookie
		if (this.hasSavedExchanges() === true) {
			return '<span class="badge badge-dark">' + selectCount + '</span> <i class="fa fa-exchange" aria-hidden="true"></i>';
		} else {
			return '<i class="fa fa-exchange" aria-hidden="true"></i> Select Exchanges!';
		}
	  },

	  getItemClass(item) {
		  var classValue = "";

		  if (this.isSelected(item) === true ) {
			  classValue = "text-success";
		  }

		  return classValue;
	  },

	  getItemHtml(item) {
		  var returnValue = "";

		  if (this.isSelected(item) === true ) {
			  returnValue = '<i class="fa fa-star favorite" />';
		  }

		  return returnValue;
	  },

	  getExchangeItems() {

		  var userExchanges = this.myExchanges;

		  function sorter(a, b) {

			  // Is this the Average Price exchange CCCAGG?
			  if (a === "CCCAGG") {
				  return -1;
			  } else if (b === "CCCAGG") {
				  return 1;
			  }

			  // is either one of the user selected exchanges?
			  else if ((userExchanges[a]) || (userExchanges[b])) {

				  if ((userExchanges[a]) && (!userExchanges[b])) {
					  // a is a user exchange so sort it lower
					  return -1;
				  } else if ((!userExchanges[a]) && (userExchanges[b])) {
					  // a is not a user exchange so sort it higher
					  return 1;
				  } else if ((userExchanges[a]) && (userExchanges[b])) {
					  // if both are user exchanges, sort alphabetically
					  return a.localeCompare(b);
				  }

			  }
			  // Everything else sort alphabetically
			  else {
				  return a.localeCompare(b);
			  }
		  }

		  // Clear previous list
		  //this.exchangeList.splice(0);
		  this.exchangeList = [];

		  if (Object.keys(this.exchanges).length > 0) {

			  // build an array of exchange names
			  for (var exchange in this.exchanges) {
				  this.exchangeList.push(exchange);
	//			  this.$set(this.exchangeList, this.exchangeList.length, exchange);
			  }

			  this.exchangeList.sort(sorter);

		  }


		  return this.exchangeList;

	  },

	  displayExchangeItem(item) {
		  if (item == "CCCAGG") {
			  return "Average Price";
		  }
		  return item;
	  },

	  getButtonVariant() {

			// If user has selected a currency, it will be stored in a cookie
			if (this.hasSavedExchanges() === true) {
				return "primary";
			} else {
				return "outline-primary";
			}
	  },




//	  initializeData() {
//		  var promisedData = this.getExchangeList();
//		  promisedData.then((exchanges) =>{
//			  this.exchanges = exchanges; // save entire object
//
//			  // build an array of exchange names
//			  for (var exchange in exchanges) {
//				  this.exchangeList.push(exchange);
//			  }
//
//			  this.exchangeList.sort();
//
//			  // Remove loading spinner
//			  this.loadingSpinner = false;
//		  });
//	  }


	  getExchangeList() {
		  // get from state
		  return this.$root.$store.dispatch('CCStore/getExchangeList');
	  },

	  toggleExchange(exchange) {

		  // disable toggling of average price exchange CCCAGG
		  if ((exchange == "CCCAGG") || (exchange == "Average Price")) {
			  return null;
		  }

		  if (this.myExchanges[exchange]) {
//			  this.$delete(this.myExchanges, exchange);
			  this.$root.$store.commit('CCStore/removeMyExchange', exchange);
			  this.showExchangeItems();
		  } else {
//			  this.$set(this.myExchanges, exchange, true);
			  this.$root.$store.commit('CCStore/addMyExchange', exchange);
			  this.showExchangeItems();
		  }

	  },

	  isSelected(exchange) {
		  if (this.myExchanges[exchange]) {
			  return true;
		  }

		  return false;
	  },

	  /**
	   * Returns true if this is a user favorite exchange.
	   */
	  isUserExchange(exchange) {
		  if (this.myExchanges[exchange]) {
			  return true;
		  }
		  return false;
	  },

	  initializeData() {

		  this.savedExchanges = JSON.parse(Cookies.get('cc-myexchanges'));

		  var promisedData = this.getExchangeList();
		  promisedData.then((exchanges) =>{
			  this.exchanges = exchanges; // save entire object

//			  var userExchanges = this.myExchanges;
//
//			  function sorter(a, b) {
//
//				  // Is this the Average Price exchange CCCAGG?
//				  if (a === "CCCAGG") {
//					  return -1;
//				  } else if (b === "CCCAGG") {
//					  return 1;
//				  }
//
//				  // is either one of the user selected exchanges?
//				  else if ((userExchanges[a]) || (userExchanges[b])) {
//
//					  if ((userExchanges[a]) && (!userExchanges[b])) {
//						  // a is a user exchange so sort it lower
//						  return -1;
//					  } else if ((!userExchanges[a]) && (userExchanges[b])) {
//						  // a is not a user exchange so sort it higher
//						  return 1;
//					  } else if ((userExchanges[a]) && (userExchanges[b])) {
//						  // if both are user exchanges, sort alphabetically
//						  return a.localeCompare(b);
//					  }
//
//				  }
//				  // Everything else sort alphabetically
//				  else {
//					  return a.localeCompare(b);
//				  }
//			  }
//
//			  // build an array of exchange names
//			  for (var exchange in exchanges) {
//				  this.exchangeList.push(exchange);
//			  }
//
//			  this.exchangeList.sort(sorter);
//
//			  // Remove loading spinner
//			  this.loadingExchanges = false;
		  });
	  }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/SelectExchanges.vue